import axios from '../axios'

const deleteLessonMaterialApi = async (materialId) => {
  return await axios.delete(`api/lms/lesson-materials/${materialId}`)
}

export default deleteLessonMaterialApi
